<div class="sdds-row mt-16 mb-16">
  <div class="sdds-col-max-12  sdds-no-padding">
    <h3>ECU Specific Function</h3>
  </div>

  <div class="sdds-col-max-12 sdds-no-padding mb-10">
    <span class="sdds-checkbox-item" style="display: initial;">
      <input class="sdds-form-input" type="checkbox" [disabled]="!canActivateEcuSpecificFunction"
        name="ecuSpecificFunctionCommand" id="ecuSpecificFunctionCommand" [checked]="ecuSpecificFunctionEnabled"
        (change)="onActivateEcuSpecificFunction()">
      <label class="sdds-form-label" style="padding-left: 0px !important;" for="ecuSpecificFunctionCommand">
        ECU Specific Function
      </label>
    </span>
  </div>

  <div class="sdds-col-max-12 sdds-no-padding mb-10" *ngIf="showConnectedDiagnosticServicesMessage">
    <div class="sdds-banner sdds-banner-info">
      <div class="sdds-banner-body">
        Activation of "ECU Specific Function" requires the "Connected Diagnostic Services" to be empty.
      </div>
    </div>
  </div>

  <div class="flex" *ngIf="ecuSpecificFunctionEnabled">
    <div class="flex-none">
      <mat-form-field appearance="fill">
        <input type="text" matInput matNativeControl [formControl]="ecuSpecificFunctionControl" />
      </mat-form-field>
    </div>

    <div class="flex-initial flex items-center">
      <button class="sdds-btn sdds-btn-secondary sdds-btn-md ml-10 sdds-no-padding" id="confirmEcuSpecificFunctionBtn"
        (click)="confirmEnteredEcuSpecificFunction()"
        [disabled]="!canConfirmEcuSpecificFunction || !canEditCategoryItems()"
        matTooltip="Assign ECU specific function">
        Update
      </button>
    </div>
  </div>
</div>
